import { useMemo } from 'react';

import { useApi } from '../../../store/SelectedHomeyStore.hooks.ts';
import { useZone } from '../../../store/zones/useZones.ts';

import { HomeyColors } from '../../../theme/HomeyColors';
import { HomeyImages } from '../../../theme/HomeyImages';
import { theme } from '../../../theme/theme';

export function ZoneFlowCard(props) {
  const { component: Component, ...rest } = props;
  const { api } = useApi();
  const { zone } = useZone({ zoneId: props.ownerId });

  const { iconUrl, iconObj, iconBackgroundColor, resourceUrl, name, isLocked } = useMemo(() => {
    const result = {
      iconUrl: null,
      iconObj: null,
      iconBackgroundColor: null,
      resourceUrl: null,
      name: props.ownerUri,
      isLocked: props.card.requiresPremium === true && api.tier !== 'premium',
    };

    if (zone != null) {
      result.iconUrl = HomeyImages.getIconForZone(zone.icon);
      result.iconBackgroundColor = HomeyColors.getColorForUri('homey:manager:zones');
      result.name = zone.name;
    }

    return result;
  }, [zone, props.card, props.ownerUri, api]);

  return (
    <Component
      {...rest}
      iconUrl={iconUrl}
      iconObj={iconObj}
      iconBackgroundColor={iconBackgroundColor}
      iconSize={theme.icon.size_medium}
      resourceUrl={resourceUrl}
      name={name}
      isLocked={isLocked}
    />
  );
}
